import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  sliderWrapper: {
    width: '100%',
    padding: '14px 92px',
    [breakpointsFunc.breakpoints.down('sm')]: {
      padding: '0 60px'
    },
    '& .slick-prev': {
      left: '-60px',
      '&:before': {
        display: 'none'
      },
      [breakpointsFunc.breakpoints.down('sm')]: {
        left: '-50px'
      }
    },
    '& .slick-next': {
      right: '-60px',
      '&:before': {
        display: 'none'
      },
      [breakpointsFunc.breakpoints.down('sm')]: {
        right: '-50px'
      }
    },
    '& button': {
      alignItems: 'center',
      justifyContent: 'center',
      color: 'inherit !important',
      display: 'inline-flex !important',
      backgroundColor: palette.common.white,
      border: 'none'
    }
  }
});
export default useStyles;